var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpowerment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.112,
    height: 25.357,
    viewBox: "0 0 18.112 25.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1714_",
    d: "M22.3,8.506V5.622a2.72,2.72,0,0,0-2.717-2.717,2.687,2.687,0,0,0-1.332.363,2.7,2.7,0,0,0-4.581,0A2.682,2.682,0,0,0,9.727,4.916,2.708,2.708,0,0,0,6,7.434v9.46a2.712,2.712,0,0,0,.388,1.4l2.329,3.883v4.277a.906.906,0,1,0,1.811,0V21.923a.9.9,0,0,0-.13-.466l-2.458-4.1a.9.9,0,0,1-.13-.465V13.605a2.665,2.665,0,0,0,.906.168,2.7,2.7,0,0,0,1.811-.706,2.669,2.669,0,0,0,3.447.145,3.611,3.611,0,0,0,2.34,1.425,6.645,6.645,0,0,0-2.164,4.571.906.906,0,1,0,1.811,0c0-1.5,1.1-3.086,3.26-4.709a.906.906,0,0,0-.543-1.63H16.867a1.813,1.813,0,0,1-1.811-1.811V10.15H21.4a.907.907,0,0,1,.906.906v5.7a.9.9,0,0,1-.2.565l-3.226,4.032a.91.91,0,0,0-.2.566v4.528a.906.906,0,1,0,1.811,0v-4.21l3.027-3.784a2.717,2.717,0,0,0,.6-1.7v-5.7A2.713,2.713,0,0,0,22.3,8.506ZM9.622,11.056a.906.906,0,1,1-1.811,0V7.434a.906.906,0,0,1,1.811,0Zm3.622,0a.906.906,0,1,1-1.811,0V5.622a.906.906,0,1,1,1.811,0Zm3.622-2.717H15.056V4.717a.906.906,0,1,1,1.811,0Zm3.622,0H18.678V5.622a.906.906,0,1,1,1.811,0Z",
    transform: "translate(-6 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerment);
export default __webpack_public_path__ + "static/media/empowerment.e444b942d89e29ba469b9f905db0bf08.svg";
export { ForwardRef as ReactComponent };